import io from 'socket.io-client';
import { SocketEvent, ActivityType, } from '@debbie/common/dist/web-sockets';
import { SOCKET_SERVER } from './config';
let socket = null;
let emitQueue = [];
export const emitEvent = (event, ...args) => {
    if (socket != null) {
        socket.emit(event, ...args);
        return;
    }
    emitQueue.push([event, ...args]);
};
let handlerQueue = [];
export const subscribeToEvent = (event, fn) => {
    if (socket != null) {
        // @ts-ignore
        socket.on(event, fn);
        return;
    }
    handlerQueue.push({ type: 'sub', event, fn });
};
export const unsubscribeFromEvent = (event, fn) => {
    if (socket != null) {
        // @ts-ignore
        socket.removeListener(event, fn);
        return;
    }
    handlerQueue.push({ type: 'unsub', event, fn });
};
const handleListenerQueue = () => {
    if (socket != null) {
        for (const handler of handlerQueue) {
            if (handler.type === 'sub') {
                socket.on(handler.event, handler.fn);
            }
            else if (handler.type === 'unsub') {
                socket.removeListener(handler.event, handler.fn);
            }
        }
        handlerQueue = [];
    }
};
const handleEmitQueue = () => {
    if (socket != null) {
        for (const events of emitQueue) {
            socket.emit(...events);
        }
        emitQueue = [];
    }
};
export const init = (authToken, selectedTenant) => {
    socket = io(SOCKET_SERVER, {
        auth: {
            token: authToken,
            tenantId: selectedTenant,
        },
        transports: ['websocket'],
        secure: true,
    });
    // Uncomment to see all websocket events received on the client
    /*socket.onAny((...data: any[]) => {
      console.log('new ws-event: ', data)
    })*/
    handleListenerQueue();
    handleEmitQueue();
};
export const watchAccount = (id) => emitEvent(SocketEvent.WATCHINGACCOUNT, id);
export const leaveAccount = (id) => emitEvent(SocketEvent.LEAVINGACCOUNT, id);
export const joinCaseWatchRoom = (id, timestamp) => emitNewUserActivity(ActivityType.WATCHINGCASE, id, { timestamp: timestamp });
export const leaveCaseWatchRoom = (id) => emitRemoveUserActivity(ActivityType.WATCHINGCASE, id);
export const startedWritingClientNote = (id) => emitNewUserActivity(ActivityType.WRITINGCLIENTNOTE, id);
export const endedWritingClientNote = (id) => emitRemoveUserActivity(ActivityType.WRITINGCLIENTNOTE, id);
export const startedWritingDebtorNote = (id) => emitNewUserActivity(ActivityType.WRITINGDEBTORNOTE, id);
export const endedWritingDebtorNote = (id) => emitRemoveUserActivity(ActivityType.WRITINGDEBTORNOTE, id);
export const caseLoaded = (tenantId, id) => {
    emitEvent(SocketEvent.CASELOADED, tenantId, id);
};
let currentActivities = [];
export const getCurrentActivities = () => currentActivities;
const emitNewUserActivity = (type, handle, data, ttl) => {
    const time = new Date().getTime();
    if (currentActivities.find((a) => a.handle === handle && a.type === type) ==
        null) {
        currentActivities.push({ type, handle, data, ttl, time });
    }
    emitEvent(SocketEvent.NEWUSERACTIVITY, {
        data,
        handle,
        time: time,
        ttl,
        type,
    });
};
const emitRemoveUserActivity = (type, handle) => {
    currentActivities = currentActivities.filter((a) => a.handle !== handle || a.type !== type);
    emitEvent(SocketEvent.REMOVEUSERACTIVITY, {
        handle,
        type,
    });
};
//# sourceMappingURL=socket.js.map